export const parseLinktoString = (link: string) => {
  return link
    ?.toLowerCase()
    ?.replace(/[^\w]+/g, '-')
    .replace(/^-/, '')
    .replace(/-$/, '');
};
